import {useEffect} from 'react'

/** Sets location to current url or location param if provided, which gives a nice history
 * @param {string?} location
 */
export default function useSetLocation(location = undefined) {
    useEffect(() => {
        document.title = location ? location : `Airlinq Online - ${document.location.pathname}`
    }, [])
}